import { Box, Icon } from 'shared/ui'

type IRatingStarsProps = {
  rating: number
  size?: number
}

export const RatingStars = ({ rating, size = 14 }: IRatingStarsProps) => {
  const decimal = Math.round((rating % 1) * 10) / 10
  const rounded =
    decimal < 0.3
      ? Math.floor(rating)
      : decimal < 0.8
      ? Math.floor(rating) + 0.5
      : Math.ceil(rating)
  const fullStars = Math.floor(rounded)
  const hasHalf = rounded % 1 !== 0

  return (
    <Box display={'flex'} gap={'2px'} alignItems={'center'}>
      {Array.from({ length: 5 }, (_, i) => {
        const pos = i + 1
        if (pos <= fullStars) {
          return <Icon key={pos} icon='starFilled1' fontSize={size} color='var(--yellow-70)' />
        }
        if (hasHalf && pos === fullStars + 1) {
          return <Icon key={pos} icon='starHalf' fontSize={size} color='var(--yellow-70)' />
        }
        return <Icon key={pos} icon='starFilled1' fontSize={size} color='var(--gray-30)' />
      })}
    </Box>
  )
}
